import { DemoQuestions } from './DemoQuestions.js';

export const computeTotalScoreFromQuestions = (questions = []) => {
	if (!Array.isArray(questions) || !questions.length) return 0;

	//questions = DemoQuestions;

	const items = questions.map((q) => {
		const correctChoices = Array.isArray(q.correctChoices) ? q.correctChoices : [];
		const correctIds = correctChoices.map(c => String(c.id));

		const inputs = Array.isArray(q.inputs) ? q.inputs : [];
		const selectedIds = inputs.map(i => String(i.choiceId));

		// Se non ho risposte corrette configurate o non è stata data alcuna risposta, punteggio 0
		if (!correctIds.length || !selectedIds.length) {
			return 0;
		}

		// quante risposte corrette sono state selezionate (anche in multipla)
		const matchedCorrectCount = selectedIds.filter(id => correctIds.includes(id)).length;

		// Se è presente almeno una risposta sbagliata:
		// -> il numero di risposte selezionate è maggiore del numero di risposte corrette trovate
		const hasWrongAnswer = selectedIds.length > matchedCorrectCount;

		// Regola 1: in presenza anche solo di una risposta errata, punteggio = 0
		if (hasWrongAnswer || matchedCorrectCount === 0) {
			return 0;
		}

		// Numero totale di risposte corrette previste dalla domanda
		const numCorrectChoices = correctIds.length || 1;

		// Regola 2: in presenza di risposte corrette (anche parziali),
		// il punteggio è proporzionale:
		// ogni risposta corretta vale 1 / numCorrectChoices
		let score = matchedCorrectCount * (1 / numCorrectChoices);

		// Clamp per sicurezza
		if (score > 1) score = 1;
		if (score < 0 || !Number.isFinite(score)) score = 0;

		return score;
	});
	
	const totalScoreRaw = items.reduce((sum, it) => sum + it, 0);
	return Math.round(totalScoreRaw * 100) / 100;
};
